import { WalletBalanceResponse } from 'types/api/response/wallet-balance-response'

import { api } from './api'
import { moneyObjectHeader } from './money-object-header'

export const getWalletBalance = (userId: number) =>
  api.get<WalletBalanceResponse>(`users/${userId}/balance`, { headers: moneyObjectHeader })
